jQuery(document).ready(function ($) {
    if(jQuery().slick) {
        $('.slick-inline').slick();
        $('.carousel-tabs-section-widget ul.tabs li.tab label').click(function () {
            var thisTabNumber = $(this).attr('data-tab-number');
            var thisCarousel = $(this).closest('.tabs-group').find('.tab-content.tab-content-' + thisTabNumber + ' .slick-inline');
            if ($(thisCarousel).hasClass('needs-slick-re-init')) {
                $(thisCarousel).slick('unslick');
                $(thisCarousel).slick();
                $(thisCarousel).removeClass('needs-slick-re-init');
            }
        });
        $('.carousel-tabs-section-widget .tab-content > h3 > label').click(function () {
            var thisCarousel = $(this).closest('.tab-content').find('.slick-inline');
            if ($(thisCarousel).hasClass('needs-slick-re-init')) {
                $(thisCarousel).slick('unslick');
                $(thisCarousel).slick();
                $(thisCarousel).removeClass('needs-slick-re-init');
            }
        });
    }

    $('.c2e img').each(function(){
        var thisImgSrc = $(this).attr('src');
        $(this).wrap('<a href="' + thisImgSrc + '" class="c2e-link"></a>');
        if($(this).closest('.c2e').hasClass('with-tag')){
            $('<span class="c2e-text">+ CLICK TO ZOOM</span>').insertAfter($(this));
        }
    });
    if(jQuery().colorbox) {
        $("a.c2e-link").colorbox({maxWidth:'95%',maxHeight:'95%'});
    }


});

